export default __webpack_public_path__ + "static/media/logo-dark.79408af0.png";